// extracted by mini-css-extract-plugin
module.exports = {"d10yab73":"d10yab73","r1vs2vgs":"r1vs2vgs","wxsl1tt":"wxsl1tt","c1qjr1x4":"c1qjr1x4"};